import {useTranslation} from 'react-i18next';

import NodeEditorLayout from '../NodeEditorLayout';
import {SingleSelect} from '../../../../../common/newSelect';
import type {SelectOption} from '../../../../../common/newSelect';
import {NodeEditorV2Props} from '../types';

const FormSubmittedEditorV2 = ({
    nodeConfig,
    setNodeConfig,
    availableForms = [],
    availableFormsLoading,
    readOnly
}: NodeEditorV2Props) => {
    const {t} = useTranslation();

    const options: SelectOption[] = [
        {value: '', label: t('Any form')},
        ...availableForms.map(form => ({value: form.id, label: form.title})),
    ];

    const selectedTitle = availableForms.find(form => form.id === nodeConfig.formId)?.title || nodeConfig.formTitle;

    const handleChange = (formId: string) => {
        const form = availableForms.find(candidate => candidate.id === formId);

        // "Any form" drops both keys: the API's draft validator rejects a null.
        setNodeConfig({
            ...nodeConfig,
            formId: form?.id,
            formTitle: form?.title,
        });
    };

    return (
        <NodeEditorLayout
            summary={selectedTitle
                ? t('Runs every time a guest submits {{form}}. Their answers, email and phone are available to the steps below.', {form: selectedTitle})
                : t('Runs every time a guest submits any form. Their answers, email and phone are available to the steps below.')}
        >
            {/* `loading` stays undefined once settled: only a real form list proves a stored one is gone. */}
            <SingleSelect
                label={t('Form')}
                value={nodeConfig.formId ?? ''}
                options={options}
                onChange={handleChange}
                unknownLabel={nodeConfig.formTitle || undefined}
                loading={availableFormsLoading || undefined}
                disabled={readOnly}
            />
        </NodeEditorLayout>
    );
};

export default FormSubmittedEditorV2;
